module.exports = __webpack_public_path__ + "assets/adobe-analytics.d3092556.svg";